export const MASS_POST_SALE_JOBS_SLICE_NAME = '@@massPostSaleJobs';
